import { render, staticRenderFns } from "./registerAvenue.vue?vue&type=template&id=975d31e8"
import script from "./registerAvenue.vue?vue&type=script&lang=js"
export * from "./registerAvenue.vue?vue&type=script&lang=js"
import style0 from "./registerAvenue.vue?vue&type=style&index=0&id=975d31e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports